var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "", "align-center": "" } },
    [
      _c(
        "v-layout",
        { attrs: { "justify-center": "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "table-btn mr-1",
              attrs: { small: "", icon: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("open-table")
                }
              }
            },
            [_vm._v("\n      Table\n    ")]
          ),
          _vm._v(" "),
          _vm.hasInsidePlanButton
            ? _c(
                "v-btn",
                {
                  staticClass: "table-btn ml-1",
                  attrs: { small: "", icon: "", disabled: false },
                  on: {
                    click: function($event) {
                      return _vm.$emit("switch-visible-data")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t(_vm.visibleDataButtonLabel)) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1974f448", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1974f448","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/Toolbar.vue
// module id = null
// module chunks = 